import { cn, Tooltip } from "@aurem/ui";
import { BottomNavigationItem } from "../types";

type Props = {
  item: BottomNavigationItem;
};

export const BottomNavigationButton = ({ item }: Props) => {
  return (
    <Tooltip content={item.text} placement="top" offset={12}>
      <button
        type="button"
        onClick={item.onClick}
        aria-label={item.text}
        aria-current={item.active ? "page" : undefined}
        className={cn(
          "flex items-center justify-center w-10 h-10 shrink-0 rounded-full transition-colors",
          item.active
            ? "bg-white text-accent-500"
            : "text-white/70 hover:text-white active:bg-white/15",
        )}
      >
        {item.icon}
      </button>
    </Tooltip>
  );
};
